import {ProductClass} from 'app/blocks/model/product-class.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IProductClass} from 'app/blocks/model/product-class.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class ProductClassService extends EntityCrudService<IProductClass> {
    constructor(http: HttpClient) {
        super(http, Resource.PRODUCT_CLASSES, (obj?) => new ProductClass(obj));
    }
}
